module.exports = __webpack_public_path__ + "img/icon-tasks-blue.7ed31815.svg";